import type { TripPlannerSurfaceActivityEntry } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityEntryTypes'
import { formatEntityActivityDisplayText } from 'tripPlanner/assistant/surfaceSnapshots/surfaceActivityDisplayText'
import { toAssistantSurfaceId } from 'tripPlanner/assistant/surfaceSnapshots/assistantSurfacePlainText'

type PlaceDrawerOpenedSourcePath =
  | 'trip_planner.list.row'
  | 'trip_planner.chat.place_link'
  | 'trip_planner.chat.place_search_link'
  | 'trip_planner.drawer.ask_ai_bubble'
  | 'trip_planner.itinerary.learn_more'
  | 'trip_planner.drawer.things_to_do_tile'

// Text carries grouping identity; structured fields retain the same ID for domain lookups.
export function buildPlaceDrawerOpenedActivityEntry(
  placeName: string,
  sourcePath: PlaceDrawerOpenedSourcePath,
  googlePlaceId: string,
): TripPlannerSurfaceActivityEntry {
  const normalizedPlaceId = toAssistantSurfaceId(googlePlaceId)
  return {
    kind: 'place_drawer_opened',
    label: 'Opened place details',
    displayText: formatEntityActivityDisplayText(`Opened details for "${placeName}"`, normalizedPlaceId),
    sourcePath,
    dataClassification: 'personalised_surface',
    occurredAt: new Date().toISOString(),
    ...(normalizedPlaceId !== undefined ? { fields: [{ key: 'placeId', value: normalizedPlaceId, dataClassification: 'personalised_surface' }] } : {}),
  }
}
